import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'

import { ADMIN_DASHBOARD_LAYOUT } from '../lib/admin-dashboard-layout'

function MetricCardSkeleton() {
  return (
    <Card
      elevation={0}
      sx={{ border: '1px solid #e2e8f0', borderRadius: '10px', minHeight: 174 }}
    >
      <CardContent sx={{ px: 3, pt: 3, pb: 3 }}>
        <Skeleton variant="rounded" width={48} height={48} sx={{ mb: 2, borderRadius: '10px' }} />
        <Skeleton variant="text" width="40%" height={36} sx={{ mb: 1 }} />
        <Skeleton variant="text" width="70%" height={20} />
      </CardContent>
    </Card>
  )
}

function TableRowSkeleton() {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: '1fr 120px 100px 100px',
        gap: 2,
        py: 1.5,
        borderBottom: '1px solid #e5e7eb',
      }}
    >
      <Skeleton variant="text" height={24} />
      <Skeleton variant="rounded" width={80} height={24} sx={{ borderRadius: 9999 }} />
      <Skeleton variant="text" height={24} />
      <Skeleton variant="rounded" width={72} height={32} />
    </Box>
  )
}

export function AdminDashboardSkeleton() {
  return (
    <Box aria-busy="true" aria-label="Loading admin dashboard" data-testid="admin-dashboard-skeleton">
      <Grid
        container
        spacing={ADMIN_DASHBOARD_LAYOUT.metricGridGap}
        sx={{ mb: ADMIN_DASHBOARD_LAYOUT.metricsToRecentGap }}
      >
        {Array.from({ length: 4 }, (_, i) => (
          <Grid key={i} item xs={12} sm={6} lg={3}>
            <MetricCardSkeleton />
          </Grid>
        ))}
      </Grid>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: 2,
          mb: ADMIN_DASHBOARD_LAYOUT.recentSectionHeaderGap,
        }}
      >
        <Skeleton variant="text" width={180} height={28} />
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
          <Skeleton
            variant="rounded"
            width={ADMIN_DASHBOARD_LAYOUT.searchWidth}
            height={42}
            sx={{ borderRadius: '10px', maxWidth: '100%' }}
          />
          <Skeleton
            variant="rounded"
            width={ADMIN_DASHBOARD_LAYOUT.filterWidth}
            height={42}
            sx={{ borderRadius: '10px', maxWidth: '100%' }}
          />
        </Stack>
      </Box>

      <Card elevation={0} sx={{ border: '1px solid #e5e7eb', borderRadius: '10px', overflow: 'hidden' }}>
        {Array.from({ length: 5 }, (_, i) => (
          <Box key={i} sx={{ px: 3 }}>
            <TableRowSkeleton />
          </Box>
        ))}
      </Card>

      <Skeleton
        variant="rounded"
        height={ADMIN_DASHBOARD_LAYOUT.paginationMinHeight}
        sx={{ mt: 1, borderRadius: '4px' }}
      />
    </Box>
  )
}
